module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/iPhone-X-7a0e7a89c53e7031714061b63958a908.svg";